import { apiNerisService } from './apiNerisService';
import { serializeParams } from '../utils/serializeParams';

export const incidentsApi = {
  getIncidents({
    page = 1,
    searchQuery,
    start_dt,
    end_dt,
    pageSize,
    type,
    status,
    nerisStatus,
    department,
    responseTimeObj,
  }) {
    const timezone =
      start_dt || end_dt ? new Date().getTimezoneOffset() / 60 : null;

    const normalizeDepartment = (department) => {
      if (!department) return null;
      return Array.isArray(department) ? department : [department];
    };

    return apiNerisService
      .get(`/incidents`, {
        params: {
          page,
          search: searchQuery?.length > 0 ? searchQuery : null,
          start_dt,
          end_dt,
          timezone,
          limit: pageSize,

          type,
          status,
          neris_status: nerisStatus,
          department: normalizeDepartment(department),
          ...responseTimeObj,
        },
        paramsSerializer: serializeParams,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getIncidentInfo(id) {
    return apiNerisService
      .get(`/incidents/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  deleteIncident(id) {
    return apiNerisService
      .delete(`/incidents/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  uploadIncidentXml(formData) {
    const user = JSON.parse(localStorage.getItem('user'));

    return apiNerisService
      .post(`/upload?user=${user.email || user.fullName || null}`, formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getIncidentsOverview({ start_dt, end_dt, department }) {
    const timezone = new Date().getTimezoneOffset() / 60;
    const normalizeDepartment = (department) => {
      if (!department) return null;
      return Array.isArray(department) ? department : [department];
    };

    return apiNerisService
      .get(`/overview`, {
        params: {
          start_dt,
          end_dt,
          department: normalizeDepartment(department),
          timezone,
        },
        paramsSerializer: serializeParams,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getIncidentsCoordinates(dateRange) {
    return apiNerisService
      .get(`/coordinates?time=${dateRange}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getImportLog(page = 1, searchQuery, limit) {
    return apiNerisService
      .get(`/import/log`, {
        params: {
          page,
          search: searchQuery?.length > 0 ? searchQuery : null,
          limit,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  forceImport(id) {
    return apiNerisService
      .post(`/import/force/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  downloadImport(id) {
    return apiNerisService
      .get(`/import/download/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  syncNeris(id) {
    return apiNerisService
      .post(`/neris/sync/${id}`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  /**
   * Retrieves form settings configuration for incidents
   * @param {Object} params - Parameters object
   * @param {string} params.incident - The incident ID (required)
   * @param settings
   */
  formSettings(params, settings = {}) {
    return apiNerisService
      .get(`/form/settings`, {
        params,
        settings,
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  saveIncidentsForm(id, data) {
    return apiNerisService
      .patch(`/incident/${id}`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getDepartmentsList(id) {
    return apiNerisService
      .get(`/departments`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  saveNotes(id, note) {
    return apiNerisService
      .patch(`/incident/${id}/note`, { note })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getNote(id) {
    return apiNerisService
      .get(`/incident/${id}/note`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getFormSettings(config) {
    return apiNerisService
      .get(`/form/settings/get`, config)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  saveFormSettings(data) {
    return apiNerisService
      .patch(`/form/settings`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getTypeFormSettings() {
    return apiNerisService
      .get(`/incident/type/form`)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  saveTypeFormSettings(data) {
    return apiNerisService
      .patch(`/incident/type`, data)
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getAutocompleteOptions(enumClass, searchValue) {
    return apiNerisService
      .get(`/info/enum`, {
        params: {
          class: enumClass,
          search: searchValue,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
  getIncidentTypeOptions(searchValue) {
    return apiNerisService
      .get(`/incident/type`, {
        params: {
          search: searchValue,
        },
      })
      .then((response) => {
        return response;
      })
      .catch((error) => {
        return error;
      });
  },
};
